import type { FloatingAlign, FloatingPlacement, FloatingSide } from './FloatingPlacement';

export type ParsedPlacement = {
  side: FloatingSide | null;
  align: FloatingAlign;
};

const parsePlacement = (placement: FloatingPlacement): ParsedPlacement => {
  const [base, alignment] = placement.split('-') as [FloatingSide | 'auto', 'start' | 'end' | undefined];

  return {
    side: base === 'auto' ? null : base,
    align: alignment ?? 'center',
  };
};

export default parsePlacement;
